type ChatBodyProps = {
  children: React.ReactNode;
  dataLoc?: string;
};

export const ChatBody: React.FC<ChatBodyProps> = ({ children, dataLoc }) => (
  <div className="flex h-full flex-col" data-loc={dataLoc}>
    {children}
  </div>
);
